/**
 * 출석 — 학부모가 자녀의 출석을 본다 (학원 화면과 동일한 주간 리스트)
 * 자녀가 속한 클래스들의 출석을 모아 날짜별로 자녀 출석 상태를 표시.
 */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import academyService from '../../services/academyService';
import BrandLoader from '../common/BrandLoader';
import WeekList from './WeekList';

const pad = (n) => String(n).padStart(2, '0');
const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
const norm = (v) => (!v ? null : (typeof v === 'string' ? { status: v } : v));

const AttendanceCalendar = ({ academyId, kids }) => {
  const [weekData, setWeekData] = useState({});
  const [loading, setLoading] = useState(true);
  const [sel, setSel] = useState(todayStr());

  const kidKey = kids.map((k) => k.id).join(',');

  useEffect(() => {
    if (!academyId || !kidKey) { setLoading(false); return undefined; }
    let alive = true;
    (async () => {
      setLoading(true);
      const ids = kidKey.split(',');
      const classes = await academyService.getClasses(academyId);
      const myClasses = classes.filter((c) =>
        ids.some((id) => (c.studentIds || []).includes(id)));
      const data = {}; // { [date]: { [childId]: rec } }
      for (const c of myClasses) {
        // eslint-disable-next-line no-await-in-loop
        const log = await academyService.getClassAttendanceLog(academyId, c.id);
        log.forEach((d) => {
          ids.forEach((kidId) => {
            const r = norm(d.records?.[kidId]);
            if (r && r.status) {
              if (!data[d.date]) data[d.date] = {};
              data[d.date][kidId] = r;
            }
          });
        });
      }
      if (alive) { setWeekData(data); setLoading(false); }
    })();
    return () => { alive = false; };
  }, [academyId, kidKey]);

  if (loading) return <Loading><BrandLoader /></Loading>;

  return (
    <WeekList value={sel} onChange={setSel} weekData={weekData} students={kids} />
  );
};

export default AttendanceCalendar;

const Loading = styled.div`
  padding: 50px 0;
`;
